import { createContext, useContext } from 'react';
import { useFavourites } from './useFavourites';

export const FavouritesContext = createContext(null);

export function useFavouritesContext() {
  return useContext(FavouritesContext);
}

export { useFavourites };
